import React, { useState } from "react";
import Classes from "./Preferences.module.css";
import { useSelector } from "react-redux";
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import backend from "../../../../../../../api";
import { setUserData } from "../../../../../../../redux-store/auth/actions";
import { useDispatch } from "react-redux";

const label = { inputProps: { 'aria-label': 'Switch demo' } };

const CustomSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#006B32',
        '&:hover': {
            backgroundColor: 'rgba(255, 87, 34, 0.08)',
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#006B32',
    },
}));

const Branding = () => {
    const { user } = useSelector((state) => state.auth);
    const userId = user._id; // Get user ID from Redux user object
    const dispatch = useDispatch();

    const [is2FAEnabled, setIs2FAEnabled] = useState(user.twoFactorAuthentication || false);

    const handleToggle2FAuth = (event) => {
        const checked = event.target.checked;
        // Directly update 2FA on the backend based on switch state
        UpdateUser(checked, 'twoFactorAuthentication').then(() => setIs2FAEnabled(checked));
    };

    // Updated function to handle user field update
    async function UpdateUser(newValue, field) {
        const body = {
            [field]: newValue, // Dynamically set the field to update
        };
        try {
            const res = await backend.put(`/api/user/${userId}`, body);
            const updatedUser = { ...user, ...res.data.data };
            await dispatch(setUserData(updatedUser)); // Update Redux store
        } catch (error) {
            console.error(`Error updating user ${field}:`, error);
            // TODO: Add user-facing error handling (e.g., toast notification)
        }
    }

    return (
        <div className={Classes.container}>
            <div className={Classes.infoSection}>
                <div className={Classes.box2Header}>
                    <h3>Security Settings</h3>
                </div>
                <div className={Classes.boxCon}>
                    <div className={'flexBetween'}>
                        <h5 className={Classes.labelDark}>2-Factor Authentication (Recommended)</h5>
                        <h5 className={Classes.label}>Via code sent to your email</h5>
                        <CustomSwitch 
                            {...label} 
                            checked={is2FAEnabled} 
                            onChange={handleToggle2FAuth} 
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Branding;